import { Injectable, computed, signal } from '@angular/core';
import { DirectTransferReferencePersonOption } from '@app/core/enums/deposit.enum';
import { Provider } from '@app/core/models/provider/provider.type';
import { ProviderBankDetails } from '@app/shared/components/direct-transfer/direct-transfer.type';

@Injectable({
  providedIn: 'root'
})
export class RpJourneyProviderService {
  private providerData = signal<Provider | null>(null);

  segmentSignal = computed(() => {
    const snapshot = this.providerData();
    return snapshot ? snapshot.segment : null;
  });

  settingsSignal = computed(() => {
    const snapshot = this.providerData();
    return snapshot?.settings!;
  });

  plusSettingsSignal = computed(() => {
    return this.settingsSignal()?.plusSettings!;
  });

  connectSettingsSignal = computed(() => {
    return this.settingsSignal()?.connectSettings!;
  });

  bnplSettingsSignal = computed(() => {
    return this.settingsSignal()?.bnplSettings!;
  });

  capsPaySettingsSignal = computed(() => {
    return this.settingsSignal()?.capsPaySettings!;
  });

  generalSettingsSignal = computed(() => {
    return this.settingsSignal()?.generalSettings!;
  });

  connectServicesSignal = computed(() => {
    return this.settingsSignal()?.connectServices!;
  });

  featuresSignal = computed(() => {
    return this.settingsSignal()?.features!;
  });

  constructor() {}

  setProviderData(data: any): void {
    this.providerData.set(data);
  }

  getProviderData(): Provider | null {
    return this.providerData();
  }

  getProviderBankDetails(): ProviderBankDetails {
    const provider = this.getProviderData();

    return {
      accountName: provider && provider.direct_transfer ? provider.direct_transfer?.bank_name : '',
      accountNumber:
        provider && provider.direct_transfer ? provider.direct_transfer?.bank_acct_number : '',
      bsb: provider && provider.direct_transfer ? provider.direct_transfer?.bank_bsb : '',
      reference:
        provider && provider.direct_transfer
          ? provider.direct_transfer?.reference
          : { text: '', value: DirectTransferReferencePersonOption.Patient }
    };
  }
}
